module.exports = __webpack_public_path__ + "media/customizations/westphalia/logo-1ef876d4ed5d4b00c2beb0b2b2683e28.png";